import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './directcss/CalendarInput.scss';
import moment from 'moment';

const CalendarInputWDateFormat = ({ 
	label, 
	customStyle = {}, 
	value, 
	onChangeCb, 
	name = '', 
	dateFormat = "MM/dd/yyyy", 
	onBlurCb, 
	preventTyping = true, 
	onKeyDown = () => { }, 
	inputClassName = "", 
	maxAllowedDate = null, 
	minAllowedDate = null, 
	allowOnlyFutureDate = false,
	showMonthDropdown = true,
	showYearDropdown = true,
	disabled = false,
	tabIndex = "0",
	isTimeInputEnabled = false,
}) => {

	const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : null);
	const [changedDate, setChangedDate] = useState("");
	const [isFocused, setIsFocused] = useState(true);
	const [minDate, setMinDate] = useState(null);

	const handleChange = (date) => {
		setSelectedDate(date);

		let formattedDate 
		if (!isTimeInputEnabled) {
			formattedDate = moment(date).format('YYYY-MM-DD');
		} else {
			formattedDate = moment.utc(date).format()
		}

		setChangedDate(formattedDate);
		onChangeCb(formattedDate);
		setIsFocused(false);
	};

	useEffect(() => {
		setSelectedDate(value ? moment(value).toDate() : null);
	}, [value]);

	useEffect(() => {
		if(minAllowedDate){
			setMinDate(minAllowedDate)
		}else if (allowOnlyFutureDate) {
			setMinDate(new Date());
		}
	}, []);

	useEffect(() => {
		if (!isFocused) {
			handleBlur(changedDate)
		}
	}, [isFocused]);

	const handleBlur = (date) => {
		if (onBlurCb) {
			onBlurCb(date);
		}
		onKeyDown();
	}

	const handleFocus = () => {
		setIsFocused(true);
	};

	const handleKeyDown = (event) => {
		if (preventTyping) {
			event.preventDefault();
		}
	};

	return (
		<div className="calendar-container" style={customStyle}>
			{label && <label className="calendar-label">{label}</label>}
			<DatePicker
				selected={selectedDate}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={() => handleBlur(changedDate)}
				onKeyDown={handleKeyDown}
				dateFormat={dateFormat}
				name={name}
				className={`calendar-input ${inputClassName}`}
				placeholderText={dateFormat}
				maxDate={maxAllowedDate}
				minDate={minDate}
				showMonthDropdown={showMonthDropdown}
				showYearDropdown={showYearDropdown}
				disabled={disabled}
				tabIndex={Number(tabIndex) || 0}
				showTimeInput={isTimeInputEnabled}
				dropdownMode = "select"
			/>
		</div>
	);
};

export default CalendarInputWDateFormat;